// filepath: apps/web/src/features/tasks/TasksRoute.tsx
//
// Route shell for the human-task inbox (FR-UI-TASK-1).
//
// Mounts the TaskInboxPage inside the authenticated app shell.
// Route registration is handled in App.tsx via AuthStateRouter.
//
// The ConflictResolverProvider is mounted here so that:
//   - TaskForm can call useConflictResolver() and render ConflictResolution.
//   - The ConflictResolution modal has a provider ancestor.

import React from "react";
import { ConflictResolverProvider } from "@/renderers/__shared__/useConflictResolver";
import { TaskInboxPage } from "./TaskInboxPage";

/**
 * TasksRoute — route-level shell.
 *
 * Wraps TaskInboxPage in the authenticated chrome + ConflictResolverProvider.
 * The ConflictResolverProvider is required because:
 *   - TaskForm calls useConflictResolver().show() on 409.
 *   - ConflictResolution calls useConflictResolver() and must have a provider ancestor.
 */
export function TasksRoute(): React.ReactElement {
  return (
    <ConflictResolverProvider>
      <TaskInboxPage />
    </ConflictResolverProvider>
  );
}
